import { useEffect, useState } from "react";
import { Accordion, Button, Container } from "react-bootstrap";
import { FaAngleDoubleUp, FaCalendarAlt, FaCheckCircle, FaDownload, FaFilePdf, FaRegTimesCircle, FaRegTrashAlt, FaTruck } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import SelectAlmacenes from "../../../components/Almacenes";
import SelectCentro from "../../../components/Centros";
import LocalMsgModalSpinner from "../../../components/LocalMsgModalSpinner";
import * as env from '../../../env';
import { httpApiDownloadFileInventario, httpApiGetText, httpApiPostText } from "../../../lib";
import DataTable from "react-data-table-component";
import { exportToExcel } from "../../../util";
import MsgDialog from "../../../components/MsgDialog";
import BarraMenuHz from "../../../components/BarraMenoHz";
import { SetEntornoEmp } from "../../../redux/store/Actions";
import BajarArchivoNube from "./ModalDescargaDocs";

// texto un poco mas grande para el detalle del ajuste que se muestra en el modal
const estilosDetalleAjuste = {
    headRow: {
      style: {
        backgroundColor: "#F0F0F0",
        fontSize: "14px",
      },
    },
    cells: {
      style: {
        fontSize: "14px",
      },
    },
};

const GestionMuestras = () =>{

    let emp: any = useSelector((state: any) => state.emp);  
    const [hbltBtnAbrir, setHbltBtnAbrir] = useState(true); 
    let [formData, setFormData] = useState({ Pais: "CL", Anno: "", Mes: "",  Centro: "", Almacen: "", Muestra_ref: 0});
    const [sHCarga, setSHCarga] = useState(false);      
    let [records, setRecords] = useState(new Array<any>());  
    let [arrData, setArrData] = useState(new Array<any>());     
    const [showMsgApiResponse, setShowMsgApiResponse] = useState(false); 
    const [MsgApiResponse, setMsgApiResponse] = useState("");   
    const [showAutoriza, setShowAutoriza] = useState(false);         
    const [showAjuste, setShowAjuste] = useState(false);  
    const [showRechaza, setShowRechaza] = useState(false);          
    const [showElimina, setShowElimina] = useState(false);              
    const [showSubirNube, setShowSubirNube] = useState(false); 
    const [muestra, setMuestra] = useState(0);                
    const dispatch = useDispatch();
    let [itemgestion, setGestion] = useState<any>();
    let [clasifElim, setClasifElim] = useState(new Array<any>());
    const [clasifElimId, setClasifElimId] = useState("");
    let [detalleAjuste, setDetalleAjuste] = useState(new Array<any>());

    // la api puede responder el json como objeto o como texto serializado
    const parseaRespuesta = (texto: string) => {
        let rsp: any = texto;
        for (let i = 0; (i < 2) && (typeof rsp === "string"); i++){
            try {
                rsp = JSON.parse(rsp);
            } catch (e) {
                console.log("Error de respuesta: ", texto);
                return null;
            }
        }
        return (rsp && (typeof rsp === "object")) ? rsp : null;
    }

    // la api no es consistente con el uso de mayusculas en las claves
    const valorPorClave = (obj: any, ...claves: string[]) => {
        if (!obj || (typeof obj !== "object")){
            return undefined;
        }
        const clave = Object.keys(obj).find((k: string) =>
            claves.some((c: string) => (c.toLowerCase() === k.toLowerCase())));
        return (clave) ? obj[clave] : undefined;
    }

    let columns = [
        { name: "Centro", selector: (row:any) => row.Centro, sortable: true,  width:"90px"},
        { name: "Almacen", selector: (row:any) => row.Almacen, sortable: true,  width:"100px"},
        { name: "Estado", selector: (row:any) => row.Estado_Muestra, sortable: true,  width:"90px"},
        { name: "Muestra", selector: (row:any) => row.Muestra_ref, sortable: true,  width:"120px"},        
        { name: "Fecha Apertura", selector: (row:any) => row.Publicado_fecha, sortable: true, width:"160px", wrap:true},
        { name: "Usuario Apertura", selector: (row:any) => row.Usuario_apertura, sortable: true,   width:"150px"},
        { name: "Fecha Publicación", selector: (row:any) => row.Publicado_fecha, sortable: true, width:"160px"},            
        { name: "Usuario Publicación", selector: (row:any) => row.Publicado_usuario, sortable: true, width:"160px"},
        { name: "Diferencia", selector: (row:any) => row.Diferencia, sortable: true, width:"150px", right:true},
        { name: "Acciones", selector: (row:any) => row.Acciones, width:"200px"},      
        { name: "Estado gestión", selector: (row:any) => row.ESTADO_GESTION, sortable: true, width:"150px", omit: (!emp.permisoAnalistaMuestra)},                              
    ];
    
    const pagOptions = {
        rowsPerPageText: "Filas por páginas",
        rangeSeparatorText: "de",
        selectAllRowsItem: true,
        selectAllRowsItemText: "Todos"
    };
    
    const ValidaBtnAbrir = () => {     
        if ((formData.Anno !== "") &&
            (formData.Almacen !== "") && 
            (formData.Centro !== "")){     
                setHbltBtnAbrir(false); 
        }else{
            setHbltBtnAbrir(true); 
        }
    }

    const hndlrPeriodo = async (evnt: any) =>{
        const f: Date = evnt.target.value; 
        const yy = f.toString().split('-')[0];
        const mm = f.toString().split('-')[1];

        emp = {...emp, periodoDefault: `${yy}-${mm}`};
        dispatch(SetEntornoEmp({...emp}));  

        sessionStorage.setItem("entorno", JSON.stringify(emp));   
                
        formData = {...formData, Anno: yy, Mes: mm};
        setFormData(formData);
        ValidaBtnAbrir();                    
    }

    const hndlrOpcionCentro = (cnt: string, nal: any) =>{

        if (nal.length === 1){
            formData = {
                ...formData, 
                Centro: cnt, 
                Almacen: nal[0].split("-")[1].trim()
            };
            emp = {...emp, centroDefault: cnt, almacenDefault: nal[0].split("-")[1].trim()};     
        }else{
            formData = {
                ...formData, 
                Centro: cnt, 
                Almacen: ""
            }; 
            emp = {...emp, centroDefault: cnt, almacenDefault: ""};              
        }

        setFormData(formData);   
        dispatch(SetEntornoEmp({...emp})); 
        sessionStorage.setItem("entorno", JSON.stringify(emp));     

        ValidaBtnAbrir();   
         
    }

    const hndlrOpcionAlmacen = (evnt: any) =>{
        formData = {...formData, [evnt.target.id]: evnt.target.value.split("-")[0].trim()};
        setFormData(formData);     
        
        emp = {...emp, almacenDefault: evnt.target.value};
        dispatch(SetEntornoEmp({...emp}));  

        sessionStorage.setItem("entorno", JSON.stringify(emp));  

        ValidaBtnAbrir();                               
    }   

    // Carga las clasificaciones de rechazo/eliminación y abre el diálogo de confirmación
    const abreDialogoClasificacion = async (muestra_ref: number, tipo: string, mostrarDialogo: any) => {

        setMuestra(muestra_ref);
        setClasifElim([]);
        setClasifElimId("");
        setSHCarga(true);

        const recurso = `${env.REACT_APP_API_URL}/api/ClasificacionMuestra/ListarClasifEliminar?Pais=${formData.Pais}&tipo=${tipo}`;
        const response = await httpApiGetText(recurso, {
            'Content-Type': 'application/json',
            'Rosen-API-Key': `${env.REACT_APP_Rosen_API_Key}`,
            'Rosen-API-Secret': `${env.REACT_APP_Rosen_API_Secret}`,
        });
        setSHCarga(false);

        let lista: any[] = [];
        if (response.code < 400){
            try {
                lista = JSON.parse(response.message);
            } catch (e) {
                console.log("Error de respuesta: ", response.message);
            }
        }

        if (lista.length <= 0){
            setMsgApiResponse("No fue posible obtener las clasificaciones disponibles.");
            setShowMsgApiResponse(true);
            return;
        }

        setClasifElim([...lista]);

        // con un único registro queda seleccionado por defecto
        if (lista.length === 1){
            setClasifElimId(`${lista[0].ELIM_ID}`);
        }

        mostrarDialogo(true);
    }

    const selectClasificacion = (
        <div>
            <label className="form-label">Seleccionar clasificación *</label>
            <select className="form-select" value={clasifElimId} onChange={(evnt: any) => setClasifElimId(evnt.target.value)}>
                {(clasifElim.length > 1) && <option value="">Seleccione una opción</option>}
                {clasifElim.map((obj: any, index: number) => <option key={index} value={obj.ELIM_ID}>{obj.ELIM_DESCRIPCION}</option>)}
            </select>
        </div>
    );

    const columnasDetalleAjuste = [
        { name: "SKU", selector: (row:any) => row.Sku, sortable: true, width:"150px"},
        { name: "Tipo Clasificación", selector: (row:any) => row.Descripcion, sortable: true, wrap:true},
    ];

    // con mas de 5 registros la tabla queda con scroll
    const detalleAjusteTabla = (
        <div className="mx-3">
            <label className="form-label">Se encontraron productos clasificados como Paridad y Ajuste:</label>
            <DataTable
                columns={columnasDetalleAjuste}
                data={detalleAjuste}
                customStyles={estilosDetalleAjuste}
                highlightOnHover
                fixedHeader={(detalleAjuste.length > 5)}
                fixedHeaderScrollHeight="300px"
            />
        </div>
    );

    const AutorizarSupervisor = async () => {

        setShowAutoriza(false);

        const data = {
            Pais: formData.Pais,
            Anno: formData.Anno,
            Mes: formData.Mes,
            Centro: formData.Centro,
            Almacen: formData.Almacen,
            Muestra_ref: muestra,
            Estado_Clasificacion:"2",
            Usu_Autoriza: emp.user
        };
     
        setSHCarga(true);
        const recurso = `${env.REACT_APP_API_URL}/api/ClasificacionMuestra/CambiaEstadoAutorizacion`
        const response = await httpApiPostText(recurso,"POST", {
            'Content-Type': 'application/json',
            'Rosen-API-Key': `${env.REACT_APP_Rosen_API_Key}`,
            'Rosen-API-Secret': `${env.REACT_APP_Rosen_API_Secret}`,
        }, data);
        setSHCarga(false);

        if (response.code >= 400){
            // mensaje de error aquí...
            setMsgApiResponse(JSON.parse(response.message).Message);
            setShowMsgApiResponse(true);
        }else{

            btnBuscar();

            setMsgApiResponse("Registro Actualizado Exitosamente");
            setShowMsgApiResponse(false);
        }
    }  

    const AutorizarAjuste = async () => {

        setShowAjuste(false);

        const data = {
            Pais: formData.Pais,
            Anno: formData.Anno,
            Mes: formData.Mes,
            Centro: formData.Centro,
            Almacen: formData.Almacen,
            Muestra_ref: muestra,
            Estado_Clasificacion:"3",
            Usu_Autoriza: emp.user
        };
        setSHCarga(true);
        const recurso = `${env.REACT_APP_API_URL}/api/ClasificacionMuestra/CambiaEstadoAutorizacion`
        const response = await httpApiPostText(recurso,"POST", {
            'Content-Type': 'application/json',
            'Rosen-API-Key': `${env.REACT_APP_Rosen_API_Key}`,
            'Rosen-API-Secret': `${env.REACT_APP_Rosen_API_Secret}`,
        }, data);
        setSHCarga(false);
        if (response.code >= 400){
            // mensaje de error aquí...
            setMsgApiResponse(JSON.parse(response.message).Message);
            setShowMsgApiResponse(true);
        }else{

            btnBuscar();

            // solo el ajuste retorna el detalle de SKU y tipo de clasificación
            console.log("Respuesta api ajuste: ", response.message);

            const rsp = parseaRespuesta(response.message);
            const mensaje = valorPorClave(rsp, "Mensaje", "Message") || "Registro Actualizado Exitosamente";
            const detalle: any[] = (Array.isArray(rsp) ? rsp : valorPorClave(rsp, "Detalle", "Detail")) || [];

            const items = detalle.map((obj: any) => ({
                Sku: `${valorPorClave(obj, "MUE_DET_INV_ITEM_ID", "SKU") || ""}`,
                Descripcion: `${valorPorClave(obj, "DESCRIPCION") || ""}`
            }));

            setDetalleAjuste([...items]);
            setMsgApiResponse(`${mensaje}`);
            setShowMsgApiResponse(true);
        }
    }

    const RechazaMuestra = async () => {
        
        setShowRechaza(false);

        const data = {
            Pais: formData.Pais,
            Anno: formData.Anno,
            Mes: formData.Mes,
            Centro: formData.Centro,
            Almacen: formData.Almacen,
            Muestra_ref: muestra,
            Estado_Clasificacion:"5",
            Usu_Autoriza: emp.user,
            ELIM_ID: clasifElimId
        };

        setSHCarga(true);
        const recurso = `${env.REACT_APP_API_URL}/api/ClasificacionMuestra/CambiaEstadoAutorizacion`
        const response = await httpApiPostText(recurso,"POST", {
            'Content-Type': 'application/json',
            'Rosen-API-Key': `${env.REACT_APP_Rosen_API_Key}`,
            'Rosen-API-Secret': `${env.REACT_APP_Rosen_API_Secret}`,
        }, data);
        setSHCarga(false);

        if (response.code >= 400){
            // mensaje de error aquí...
            setMsgApiResponse(JSON.parse(response.message).Message);
            setShowMsgApiResponse(true);
        }else{
            btnBuscar();

            setMsgApiResponse("Registro Actualizado Exitosamente");
            setShowMsgApiResponse(false);
        }
    }   
    
    const EliminaMuestra = async () => {
        
        setShowElimina(false);

        const data = {
            Pais: formData.Pais,
            Anno: formData.Anno,
            Mes: formData.Mes,
            Centro: formData.Centro,
            Almacen: formData.Almacen,
            Muestra_ref: muestra,
            Estado_Clasificacion:"4",
            Usu_Autoriza: emp.user,
            ELIM_ID: clasifElimId
        };
        setSHCarga(true);
        const recurso = `${env.REACT_APP_API_URL}/api/ClasificacionMuestra/CambiaEstadoAutorizacion`
        const response = await httpApiPostText(recurso,"POST", {
            'Content-Type': 'application/json',
            'Rosen-API-Key': `${env.REACT_APP_Rosen_API_Key}`,
            'Rosen-API-Secret': `${env.REACT_APP_Rosen_API_Secret}`,
        }, data);
        setSHCarga(false);

        if (response.code >= 400){
            // mensaje de error aquí...
            setMsgApiResponse(JSON.parse(response.message).Message);
            setShowMsgApiResponse(true);
        }else{
            btnBuscar();

            setMsgApiResponse("Registro Actualizado Exitosamente");
            setShowMsgApiResponse(false);
        }
    }    

    const cambioGestion = async (item: any) => {

        setSHCarga(true);
        const data = {
            "Pais": "CL",
            "Anno": item.Anno,
            "Mes": item.Mes,
            "Centro": item.Centro,
            "Almacen": item.Almacen,
            "Muestra_ref" : item.Muestra_ref,
            "ESTADO_GESTION": (item.ESTADO_GESTION === "GESTIONADO") ? "NO GESTIONADO" : "GESTIONADO",
            "USUARIO_ESTADO_GESTION":emp.user 
        };
         const recurso = `${env.REACT_APP_API_URL}/api/MuestraGestion`;     
        const response = await httpApiPostText(recurso,'POST', {
            'Content-Type': 'application/json',
            'Rosen-API-Key': `${env.REACT_APP_Rosen_API_Key}`,
            'Rosen-API-Secret': `${env.REACT_APP_Rosen_API_Secret}`,
        }, data);
        setSHCarga(false);       
        if(response.code >= 400){
            setMsgApiResponse(`${response.message}`);
            setShowMsgApiResponse(true);
        }else{

            setMsgApiResponse(`${response.message}`);
            setShowMsgApiResponse(true);    
            btnBuscar();        
        } 
        setGestion(null);
    }        

    const gestion = (item: any) => {
        setGestion(item);
    }  
    
    const EsFechaValida = (fecha: string) => {
        
        if (!fecha) return false;

        const date = new Date(fecha);

        if (isNaN(date.getTime())) return false;

        // Fecha mínima inválida (DateTime.MinValue)
        if (date.getFullYear() === 1) return false;

        return true;
    };  
    
    const descargaPdf = async (centro: any, almacen: any, muestra: any) =>{

        setSHCarga(true);
        const recurso = `${env.REACT_APP_API_URL}/api/ClasifMuestraPdf?Pais=CL&Anno=${formData.Anno}&Mes=${formData.Mes}&Centro=${centro}&Almacen=${almacen}&Muestra_ref=${muestra}`;   
        const response = await httpApiDownloadFileInventario(recurso, {
            'Content-Type': 'application/json',
            'Rosen-API-Key': `${env.REACT_APP_Rosen_API_Key}`,
            'Rosen-API-Secret': `${env.REACT_APP_Rosen_API_Secret}`,
        });
        setSHCarga(false);
    }    
    
    // el export es sincronico: se cede el hilo para que el spinner alcance a pintarse
    const exportaExcel = async () => {

        setSHCarga(true);
        await new Promise((resolve: any) => setTimeout(resolve, 0));
        exportToExcel("TablaMuestra", records);
        setSHCarga(false);
    }

    const btnBuscar = async () =>{

        setSHCarga(true);
        const recurso = `${env.REACT_APP_API_URL}/api/ClasificacionMuestraList?Pais=CL&Anno=${formData.Anno}&Mes=${formData.Mes}&Centro=${formData.Centro}&Almacen=${formData.Almacen}`;     
        const response = await httpApiGetText(recurso,{
            'Content-Type': 'application/json',
            'Rosen-API-Key': `${env.REACT_APP_Rosen_API_Key}`,
            'Rosen-API-Secret': `${env.REACT_APP_Rosen_API_Secret}`,
        });

        const Dta = await JSON.parse(response.message); 

        arrData = [...Dta];
        setArrData([...Dta]);
        setSHCarga(false);  
        if (response.code >= 400){
            console.log("Error de respuesta: ", response.message);
        }else{
            const auxDta:any = [];
            Dta.map((obj: any, index: number)=>{
                const newObj = {
                    ...obj, 
                    Acciones: <div  className=' d-flex gap-1' >                    
                                    {
                                        (obj.Cantidad > 0) 
                                                ? <div  className=' d-flex gap-1' >
                                                    <a href="#!" id={`${index}`} onClick={()=>{
                                                            setFormData({...formData, Muestra_ref: obj.Muestra_ref});
                                                            setShowSubirNube(true);
                                                        }}>
                                                        <FaDownload title="Descarga de Archivos Adjuntos" color={'white'}  className='bg-secondary rounded-circle p-1 h4'/>  
                                                    </a> 
                                                  </div>    
                                                : null
                                    }
                                    {
                                        (((obj.Estado_Clasificacion === "0") || (obj.Estado_Clasificacion === "1")) && emp.permisoSupervisor)  
                                            ? 
                                                <div  className=' d-flex gap-1' >
                                                    <a href="#!" id={`${index}`} onClick={()=>{
                                                            setMuestra(obj.Muestra_ref);
                                                            setShowAutoriza(true);
                                                        }}>
                                                            <FaCheckCircle title="Autorizar Supervisor" color={'white'}  className='bg-success rounded-circle p-1 h4'/>                                                              
                                                    </a> 
                                                </div>
                                            : null
                                    }
                                    {
                                        (emp.permisoAjuste && (obj.Estado_Clasificacion  === "2"))
                                                ? <div  className=' d-flex gap-1' >
                                                    <a href="#!" id={`${index}`} onClick={()=>{
                                                            setMuestra(obj.Muestra_ref);
                                                            setShowAjuste(true);
                                                        }}>
                                                        <FaAngleDoubleUp title="Autorizar Ajuste" color={'white'}  className='bg-warning rounded-circle p-1 h4'/>                                                              
                                                    </a> 
                                                  </div>    
                                                : null
                                    }
                                    {
                                        (emp.permisoRechazaMuestra && ((obj.Estado_Clasificacion >= parseInt("0")) && (obj.Estado_Clasificacion <= parseInt("2"))))
                                                ? <div  className=' d-flex gap-1' >
                                                    <a href="#!" id={`${index}`} onClick={()=>{
                                                            abreDialogoClasificacion(obj.Muestra_ref, "RECHAZAR", setShowRechaza);
                                                        }}>
                                                        <FaRegTimesCircle title="Rechaza" color={'white'}  className='bg-warning rounded-circle p-1 h4'/>                                                              
                                                    </a> 
                                                  </div>    
                                                : null
                                    }                                                                                                                                
                                    {
                                        (emp.permisoElimina && ((obj.Estado_Clasificacion === "0") || (obj.Estado_Clasificacion === "1")))
                                                ? <div  className=' d-flex gap-1' >
                                                    <a href="#!" id={`${index}`} onClick={()=>{
                                                            abreDialogoClasificacion(obj.Muestra_ref, "ELIMINAR", setShowElimina);
                                                        }}>
                                                        <FaRegTrashAlt title="Elimina" color={'white'}  className='bg-danger rounded-circle p-1 h4'/>                                                              
                                                    </a> 
                                                  </div>    
                                                : null
                                    } 
                                    {
                                     (EsFechaValida(obj.FECHA_MUESTRA_ROBO))
                                        ?   <div>
                                                <a href="#!" id={`${index}`} onClick={()=>{
                                                        descargaPdf(obj.Centro, obj.Almacen, obj.Muestra_ref);
                                                    }}>
                                                    <FaFilePdf title="Descargar pdf" color={'white'}  className='bg-danger rounded-circle p-1 h4'/>   
                                                </a> 
                                            </div>

                                        : null                                           
                                    }                                   
                                </div> ,
                    ESTADO_GESTION: <div  className=' d-flex justify-content-center w-100' >
                                                    <a href="#!"  onClick={()=>{
                                                            gestion(obj);
                                                        }} className=" btn btn-secondary text-light" style={{fontSize: 11}}>
                                                        {
                                                            (obj.ESTADO_GESTION === null) ? "NO GESTIONADO" : obj.ESTADO_GESTION
                                                        }                                
                                                    </a> 
                                                </div>, 
                                                                                                                                 
                };
                auxDta.push(newObj);
            });
            setRecords([...auxDta]);
        }
    }

    useEffect(()=>{

        const preFiltros = () =>{
            if ((emp.periodoDefault !== "")){
                formData = { ...formData, Anno: emp.periodoDefault.split("-")[0],  Mes: emp.periodoDefault.split("-")[1]};
                setFormData(formData);                                         
            }  
            if ((emp.centroDefault !== "")){
                formData = { ...formData, Centro: emp.centroDefault.split("-")[0].trim()};
                setFormData(formData);                                        
            }    
            if ((emp.almacenDefault !== "")){
                formData = { ...formData, Almacen: emp.almacenDefault.split("-")[0].trim()};
                setFormData(formData);                                        
            }  

            ValidaBtnAbrir(); 
        }

        preFiltros();
    }, []);     
  
    return(
        <Container fluid>
            <BarraMenuHz/>  
            <div >
                <div className="text-primary ms-3 mt-3">
                        Home / Muestras / Gestión de Muestras
                </div>
                <div className="h4 mt-4 mb-4 ms-3">GESTION DE MUESTRAS</div>
            </div> 
            <Container fluid>  
                <Accordion  className="mb-4" defaultActiveKey={['0']} alwaysOpen>
                    <Accordion.Item eventKey="0" className="border shadow ">
                        <Accordion.Header><div className=" h5 text-dark">PARÁMETROS GESTIÓN</div></Accordion.Header>
                        <Accordion.Body>
                            <label className="h6 mb-3">Recuerda completar todos los campos con *</label> 
                            <div className="align-middle">
                                <FaCalendarAlt className="h5" /> 
                                <label className="ms-2 h4 ">Periodo</label>
                            </div>
                            <hr className="t-0 m-0 mb-3" />

                            <div  className="d-flex flex-column col-6">
                                <label className="m-2 ">Mes/Año</label>
                                <input type="month" id="periodo" size={8}  className="ms-2"
                                    value={`${formData.Anno}-${formData.Mes}`}
                                    onChange={hndlrPeriodo} 
                                    min="1990-01" max="9999-12"
                                />
                            </div>
                            <div className="align-middle mt-4">
                                <FaTruck className="h5" /> 
                                <label className="ms-2 h4 ">Centro y Almacen</label>
                            </div>
                            <hr className="t-0 m-0 mb-3" /> 

                            <div className="row d-flex flex-row mb-3">
                                <Container fluid className="mb-3 col-md-12 col-lg-6" >
                                    <label className="form-label">Seleccionar Centro de distribución</label>    
                                    <div><SelectCentro id="Centro" OnSeleccion={hndlrOpcionCentro}  default={emp.centroDefault} /></div>
                                </Container>
                                <Container fluid className="mb-3  col-md-12 col-lg-6" >
                                    <label className="form-label">Seleccionar Almacen </label>    
                                    <div ><SelectAlmacenes  id="Almacen" centro={formData.Centro}  OnSeleccion={hndlrOpcionAlmacen}   default={emp.almacenDefault} /></div>
                                </Container>
                            </div>

                            <div className=" col-md-12 col-lg-12 text-end">
                                <Button type="button" style={{backgroundColor:"#00B5B8"}} className=" btn border border-0" 
                                    disabled={hbltBtnAbrir} onClick={() => btnBuscar()}
                                >
                                    Buscar
                                </Button>
                            </div>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>  

                <Accordion className="mt-1" defaultActiveKey={['0']} alwaysOpen>
                    <Accordion.Item eventKey="0" className="border shadow ">
                        <Accordion.Header><div className=" h5 text-dark">MUESTRAS</div></Accordion.Header>
                        <Accordion.Body>
                           
                            <div className="row d-flex flex-row align-middle mt-2 mb-2">
                                <div  className="col-md-12 col-lg-6  d-flex align-items-center" >
                                    <Button type="button" style={{backgroundColor:"#00B5B8"}} className=" border-0"
                                        disabled={(records.length <= 0)}
                                        onClick={() => exportaExcel()}
                                    >
                                        Exportar tabla a Excel
                                    </Button>
                                </div>                       
                            </div> 
                            <div className="">
                                <DataTable 
                                    columns={columns}
                                    data={records}
                                    selectableRowsHighlight
                                    fixedHeader
                                    pagination
                                    highlightOnHover
                                    fixedHeaderScrollHeight="600px"
                                    paginationComponentOptions={pagOptions}
                                />                                
                            </div>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion> 

            </Container>
            {showSubirNube && <BajarArchivoNube
                Data={arrData}
                Show={showSubirNube}
                Title="Descargar archivos"
                BtnNokName="Cerrar"
                HanlerdClickNok={()=>{setShowSubirNube(false)}}
                HandlerPreselected={[]}     
                data={formData}           
            />}

            {showMsgApiResponse && <MsgDialog 
                Title="Gestión de Muestras"
                Icon="!"
                Show={showMsgApiResponse}
                BtnNokName=""
                BtnOkName="Cerrar"
                Message={MsgApiResponse}
                Contenido={(detalleAjuste.length > 0) ? detalleAjusteTabla : null}
                HandlerClickOk={()=>{
                    setShowMsgApiResponse(false);
                    setDetalleAjuste([]);
                }}
                HanlerdClickNok={null}
            />} 

             {showAutoriza && <MsgDialog 
                Title="Gestión de Muestras"
                Icon="!"
                Show={showAutoriza}
                BtnNokName="No, cancelar"
                BtnOkName="Si, continuar"
                Message="¿Desea continuar con el proceso de autorización por el supervisor?"
                HandlerClickOk={AutorizarSupervisor}
                HanlerdClickNok={()=>setShowAutoriza(false)}
            /> }     

            {showAjuste && <MsgDialog 
                Title="Gestión de Muestras"
                Icon="!"
                Show={showAjuste}
                BtnNokName="No, cancelar"
                BtnOkName="Si, continuar"
                Message="¿Desea continuar con el proceso de autorización de ajuste?"
                HandlerClickOk={AutorizarAjuste}
                HanlerdClickNok={()=>setShowAjuste(false)}
            /> }  

            {showRechaza && <MsgDialog 
                Title="Gestión de Muestras"
                Icon="!"
                Show={showRechaza}
                BtnNokName="No, cancelar"
                BtnOkName="Si, continuar"
                Message="¿Desea continuar con el proceso de Rechazo de muestras?"
                Contenido={selectClasificacion}
                DeshabilitaOk={(clasifElimId === "")}
                HandlerClickOk={RechazaMuestra}
                HanlerdClickNok={()=>setShowRechaza(false)}
            /> } 
            
            {showElimina && <MsgDialog 
                Title="Gestión de Muestras"
                Icon="!"
                Show={showElimina}
                BtnNokName="No, cancelar"
                BtnOkName="Si, continuar"
                Message="¿Desea continuar con el proceso de eliminación?"
                Contenido={selectClasificacion}
                DeshabilitaOk={(clasifElimId === "")}
                HandlerClickOk={EliminaMuestra}
                HanlerdClickNok={()=>setShowElimina(false)}
            /> }              

            {itemgestion && <MsgDialog 
                Title="Estado Gestión"
                Icon="!"
                Show={itemgestion ? true: false}
                BtnNokName="Cancelar"
                BtnOkName="Continuar"
                Message={itemgestion && ((itemgestion.ESTADO_GESTION === "GESTIONADO") ? "¿Desea cambiar el estado a NO GESTIONADO?" : "¿Desea cambiar el estado a GESTIONADO?")}
                HandlerClickOk={()=>{
                    cambioGestion(itemgestion);
                }}
                HanlerdClickNok={()=>setGestion(null)}
            />}                                 

            {sHCarga && <LocalMsgModalSpinner 
                Show={sHCarga}
                text="Un momento por favor, procesando..."
                color="#FF7588"
            />}             
        </Container>    
    );
}

export default GestionMuestras;